import { Catalog as e } from "./Catalog.js";
import { CatalogSearch as t } from "./CatalogSearch.js";
import { FacetCollectionConfigurations as n } from "./FacetCollectionConfigurations.js";
import { FacetFieldConfigurations as r } from "./FacetFieldConfigurations.js";
import { FacetPerformanceReportingMetrics as i } from "./FacetPerformanceReportingMetrics.js";
import { FeatureStackConfiguration as a } from "./FeatureStackConfiguration.js";
import { ListingPage as o } from "./ListingPage.js";
import { ProductListingConfiguration as s } from "./ProductListingConfiguration.js";
import { ProductListingReportingMetrics as c } from "./ProductListingReportingMetrics.js";
import { RecommendationSlotPreview as l } from "./RecommendationSlotPreview.js";
import { RecommendationsMetrics as u } from "./RecommendationsMetrics.js";
import { RuleDefinition as d } from "./RuleDefinition.js";
import { RulePreview as f } from "./RulePreview.js";
import { SearchMetrics as p } from "./SearchMetrics.js";
import { SlotConfiguration as m } from "./SlotConfiguration.js";
import { SynonymRulePreview as h } from "./SynonymRulePreview.js";
import { Synonyms as g } from "./Synonyms.js";
import { TrackingIdLocales as _ } from "./TrackingIdLocales.js";
import { Setup as v } from "./Setup.js";
import { Audiences as y } from "./Audiences.js";
import { RuleCount as b } from "./RuleCount.js";
import { CatalogFields as x } from "./CatalogFields.js";
import { Resource as S } from "@coveo/platform-client";
//#region src/resources/commerce/Commerce.ts
var C = class extends S {
	constructor(S, C) {
		super(S, C), this.api = S, this.serverlessApi = C, this.audiences = new y(S, C), this.productListingReportingMetrics = new c(S, C), this.productListingConfigurationsV2 = new s(S, C), this.searchMetrics = new p(S, C), this.trackingIdLocales = new _(S, C), this.slotConfiguration = new m(S, C), this.recommendationMetrics = new u(S, C), this.recommendationSlotPreview = new l(S, C), this.synonymRulePreview = new h(S, C), this.synonyms = new g(S, C), this.catalogSearch = new t(S, C), this.catalog = new e(S, C), this.catalogFields = new x(S, C), this.facetCollectionConfigurations = new n(S, C), this.facetPerformanceReportingMetrics = new i(S, C), this.facetFieldConfigurations = new r(S, C), this.ruleDefinition = new d(S, C), this.rulePreview = new f(S, C), this.setup = new v(S, C), this.listingPage = new o(S, C), this.ruleCount = new b(S, C), this.featureStackConfiguration = new a(S, C);
	}
};
//#endregion
export { C as CommerceResource };

//# sourceMappingURL=Commerce.js.map